<template>
  <div id="dashboard">
    <section class="bd-index-fullscreen has-page-background hero is-fullheight">
      <div class="hero-body">
        <div style="margin: 0 auto; position: relative;" >
          <div class="tile is-ancestor">
            <div class="tile is-vertical is-8">
              <div class="tile is-parent">
                <article class="tile is-child notification has-content-background-gradient">
                  <p class='is-size-7 has-text-grey-light'>{{ $t('dashboard.my-vcard') }}</p>
                  <div>
                    <router-link to="/settings">
                      <span class="is-size-4">{{ userProfile.name }} </span>
                    </router-link>
                    <!--
                    <router-link to="/settings-taghandle">@{{ userProfile.taghandle }}</router-link>
                    -->
                  </div>

                  <div v-if="!userProfile.position && !userProfile.location">
                    <router-link to="/settings"><i class="ri-add-circle-line"></i> Add Profile Details</router-link>
                  </div>
                  
                  <div>
                    <span v-if="userProfile.position">{{ userProfile.position }}&nbsp;|&nbsp;</span>
                    <span v-if="userProfile.location">{{ userProfile.location }}</span>
                  </div>
                  <!--
                  <br />
                  <div class="box has-content-background">
                    <nav class="level">
                      <div class="level-item has-text-centered">
                        <div>
                          <p class="heading">Takings</p>
                          <p class="title has-text-info">3,456</p>
                        </div>
                      </div>
                      <div class="level-item has-text-centered">
                        <div>
                          <p class="heading">Donors</p>
                          <p class="title has-text-success">123</p>
                        </div>
                      </div>
                    </nav>
                  </div>
                  -->
                  <hr />
                  <div class="columns">
                    <div class="column">
                      <router-link to="/settings"
                        v-if="this.$route.path !== '/settings'"
                        class="button is-primary is-rounded is-fullwidth is-outlined"
                        size="is-small">
                        <span class="icon is-small">
                          <i class="ri-user-line"></i> 
                        </span>
                        <span>{{ $t('dashboard.edit') }}</span>
                      </router-link>
                      <a v-else @click="closeNav"
                        class="button is-primary is-rounded is-fullwidth is-outlined"
                        size="is-small">
                        <span class="icon is-small">
                         <i class="ri-user-line"></i> 
                        </span>
                        <span>{{ $t('dashboard.edit') }}</span>
                      </a>
                    </div>
                    <!--
                    <div class="column">
                      <router-link to="/settings-taghandle"
                        class="button is-warning is-rounded is-fullwidth is-outlined"
                        size="is-small">
                        <span class="icon is-small">
                          <i class="ri-add-circle-line"></i> 
                        </span>
                        <span>Tag Handle</span>
                      </router-link>
                    </div>-->
                    <div class="column has-text-centered">
                      <button @click="logout" class="button is-danger is-rounded is-fullwidth is-outlined">
                        <span class="icon is-small">
                         <i class="ri-logout-circle-line"></i> 
                        </span>
                        <span>{{ $t('dashboard.logout') }}</span>
                      </button>
                    </div>
                  </div>
                </article>
              </div>
              <div class="tile">
                <div class="tile is-parent is-vertical has-text-centered">
                  <router-link to="/post" v-if="this.$route.path !== '/post'" class="tile is-child notification is-primary is-outlined">
                    <i class="ri-add-circle-line has-text-warning is-size-4"></i>
                    <p>{{ $t('dashboard.add-posts') }}</p>
                  </router-link>
                  <a v-else @click="closeNav" class="tile is-child notification is-primary is-outlined">
                    <i class="ri-add-circle-line has-text-warning is-size-4"></i>
                    <p>{{ $t('dashboard.add-posts') }}</p>
                    <p class="has-text-info is-size-7">[ {{ $t('dashboard.current-page') }} ]</p>
                  </a>

                  <router-link to="/posts" v-if="this.$route.path !== '/posts'" class="tile is-child notification is-success is-outlined">
                    <i class="ri-list-check-2 has-text-info is-size-4"></i>
                    <p>{{ $t('dashboard.discover-posts') }}</p>
                  </router-link>
                  <a v-else @click="closeNav" class="tile is-child notification is-success is-outlined">
                    <i class="ri-list-check-2 has-text-info"></i>
                    <p>{{ $t('dashboard.discover-posts') }}</p>
                    <p class="has-text-info is-size-7">[ {{ $t('dashboard.current-page') }} ]</p>
                  </a>
                </div>
                <div class="tile is-parent">
                  <article class="tile is-child notification has-content-background">
                    <div class="has-text-centered">
                      <img src="@/assets/logo.png" alt="Eco Whips" width="140px">
                      <!--<img src="@/assets/logo.png" alt="Osla" width="60px">-->
                    </div>
                    <hr />
                    <p>
                      <router-link to="/about" v-if="this.$route.path !== '/about'">{{ $t('dashboard.button-about') }}</router-link>
                      <a v-else @click="closeNav">
                        {{ $t('dashboard.button-about') }}
                      </a>
                    </p>
                    <!--
                    <p>
                      <router-link to="/future" v-if="this.$route.path !== '/future'">{{ $t('dashboard.button-future') }}</router-link>
                      <a v-else @click="closeNav">
                        {{ $t('dashboard.button-future') }}
                      </a>
                    </p>-->
                    <p>
                      <router-link to="/transparency" v-if="this.$route.path !== '/transparency'">{{ $t('dashboard.button-mantra') }}</router-link>
                      <a v-else @click="closeNav">
                        {{ $t('dashboard.button-mantra') }}
                      </a>
                    </p>
                    <p class="has-margin-bottom-10">
                      <router-link to="/privacy" v-if="this.$route.path !== '/privacy'">{{ $t('dashboard.button-privacy') }}</router-link>
                      <a v-else @click="closeNav">
                        {{ $t('dashboard.button-privacy') }}
                      </a>
                    </p>
                    <!--
                    <div class="locale-changer">
                      <b-field>
                        <b-select v-model="$i18n.locale" expanded>
                          <option v-for="(lang, i) in langs" :key="`Lang${i}`" :value="lang">{{ lang }}</option>
                        </b-select>
                      </b-field>
                    </div>-->
                    <!--
                    <p>
                      <router-link to="/about">Donate</router-link>
                    </p>-->
                  </article>
                </div>
              </div>
            </div>
            <div class="tile is-parent">
              <article class="tile is-child notification has-content-background">
                <p class="is-size-7 has-text-grey-light">{{ $t('dashboard.activity') }}</p>
                
                <div v-if="userPosts.length">
                  <div v-for="userPost in filterPosts" v-bind:key="userPost.value">
                    <span><a @click="detailPost(userPost)" >{{ userPost.title }}</a>&nbsp;</span>
                    <span class="has-text-grey-light is-size-7">
                      <i>{{ userPost.createdOn | formatDate }}</i>
                    </span>
                    <hr class="is-dark has-margin-y-sm" />
                  </div>
                  <router-link to="/activity"
                    v-if="this.$route.path !== '/activity'"
                    class="button is-info is-rounded is-fullwidth is-outlined"
                    size="is-small">
                    <span class="icon is-small">
                      <i class="ri-broadcast-line"></i>
                    </span>
                    <span>{{ $t('dashboard.button-activity') }}</span>
                  </router-link>
                  <a v-else @click="closeNav"
                    class="button is-info is-rounded is-fullwidth is-outlined"
                    size="is-small">
                    <span class="icon is-small">
                      <i class="ri-broadcast-line"></i>
                    </span>
                    <span>{{ $t('dashboard.button-activity') }}</span>
                  </a>
                </div>
                
                <div v-else>
                  <div class="has-padding-bottom-20">
                    {{ $t('dashboard.no-posts') }}
                  </div>
                  <div class="has-padding-bottom-20">
                    {{ $t('dashboard.para-this-panel') }}
                  </div>
                  <router-link to="/post"
                    v-if="this.$route.path !== '/post'"
                    class="button is-primary is-rounded is-fullwidth is-outlined"
                    size="is-small">
                    <span class="icon is-small">
                      <i class="ri-add-circle-line"></i> 
                    </span>
                    <span>{{ $t('dashboard.post') }}</span>
                  </router-link>
                  <a v-else @click="closeNav"
                    class="button is-primary is-rounded is-fullwidth is-outlined"
                    size="is-small">
                    <span class="icon is-small">
                      <i class="ri-add-circle-line"></i> 
                    </span>
                    <span>{{ $t('dashboard.post') }}</span>
                  </a>
                </div>
              </article>
            </div>
          </div>
        </div>
      </div>
    </section>

  </div>
</template>

<script>
import { mapState } from "vuex";
import moment from "moment";
const fb = require("../firebaseConfig.js");

export default {
  data() {
    return {
      userPost: {
        title: "",
        content: "",
        website: "",
        imageUrl: "",
        score: "",
      },
      comment: {
        postId: "",
        userId: "",
        content: "",
        postComments: 0
      },
      fullPost: {},
      postComments: [],
      showPostModal: false,
      showFeedsModal: false,
      isPostEdit: false,

      postFilterKey: 'all',

      langs: ['en', 'de'],
    };
  },
  computed: {
    ...mapState(["userProfile", "currentUser", "userPosts"]),

    filterPosts () {
      return this[this.postFilterKey]
    },

    all () {
      return this.userPosts;
      //return this.$store.getters.postsWithScore
    },
  },
  methods: {
    logout() {
      fb.auth
        .signOut()
        .then(() => {
          this.$store.dispatch("clearData");
          this.$router.push("/login");
        })
        .catch(err => {
          console.log(err);
        });
    },

    detailPost(post) {
      let docId = `${post.id}`;
      console.log("doc Id: " + docId);
      this.$router.push({ name: "PostDetails", params: { id: docId } });
    },

    closeNav(){
      this.$parent.toggleNav();
    }
    
  },
  filters: {
    formatDate(val) {
      if (!val) {
        return "-";
      }
      let date = val.toDate();
      return moment(date).fromNow();
    },
    trimLength(val) {
      if (val.length < 200) {
        return val;
      }
      return `${val.substring(0, 200)}...`;
    }
  }
};
</script>